import { render, staticRenderFns } from "./EmblavementsTabIcon.vue?vue&type=template&id=d6f08aa8"
import script from "./EmblavementsTabIcon.vue?vue&type=script&lang=js"
export * from "./EmblavementsTabIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports